import { render, staticRenderFns } from "./AgModalContainer.vue?vue&type=template&id=2573c931"
import script from "./AgModalContainer.vue?vue&type=script&lang=js"
export * from "./AgModalContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports